module.exports = __webpack_public_path__ + "static/media/golfer-7-a.99c82ee5.png";